import React, { forwardRef } from 'react'
import { Table, TableBody, TableProps, TableBodyProps } from '@mui/material'

export function MuiTableWrapper(props: TableProps) {
  return (
    <Table
      {...props}
      size="small"
      stickyHeader={true}
      style={{ tableLayout: 'fixed' }}
    />
  )
}

export const PlainTableBodyWrapper = forwardRef<HTMLTableSectionElement>(
  function PlainTableBodyWrapper(props: TableBodyProps, ref) {
    return <TableBody ref={ref} {...props} />
  },
)

export const PlainTableHeadWrapper = forwardRef<HTMLTableSectionElement>(
  function PlainTableHeadWrapper(props: TableBodyProps, ref) {
    return <TableBody ref={ref} {...props} />
  },
)
